module.exports = __webpack_public_path__ + "static/media/bitmoji_wave.9fb12043.png";